import PageCard from 'features/shared/components/card/PageCard';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import { formatDate } from 'features/shared/helpers/Formatters';
import React from 'react';
import { useTranslation } from 'react-i18next';
import RequirementFull from '../dtos/RequirementFullDTO';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';

interface Props {
  requirement: RequirementFull;
  enableDescription?: boolean;
}

const RequirementInfoCard = ({ requirement, enableDescription = false }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  return (
    <PageCard title={tLabels("requirementInfoCard.cardTitle")} bodyClassName="pb-0">
      <div className="row no-gutters">
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("requirementInfoCard.requirementNumber")}  value={requirement.requirementNumber} icon="tasks" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("requirementInfoCard.issueDate")}  value={formatDate(requirement.issueDate!)} icon="hourglass-start"  />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("requirementInfoCard.resolveDate")}  value={requirement.resolveDate ? formatDate(requirement.resolveDate) : "-"} icon="hourglass-end" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("requirementInfoCard.requirementType")}  value={requirement.requirementType?.name} icon="flag" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("requirementInfoCard.actualState")}  value={requirement.actualState?.name} icon="tag" />
        </div>
        <RenderWrapper isVisible={() => enableDescription}>
          <div className="col-auto px-sm-3 pb-2 pb-sm-3">
            <InfoItem title={tLabels("requirementInfoCard.descriptionShort")}  value={requirement.descriptionShort ? requirement.descriptionShort : "-"} icon="pen" />
          </div>
        </RenderWrapper>
      </div>
    </PageCard>
  )
}

export default RequirementInfoCard;
